export default {
    homeTitle: 'HOME',
    tech: 'TECHNICAL REPORT',
    service: 'SERVER',
    login: {
        errorTip1: 'Please enter the verification code',
        errorTip2: 'Please enter a number',
        errorTip3: 'Please enter a 6-digit number',
        errorTip4: 'Please enter the email',
        errorTip5: 'The email format is incorrect',
        successTip1: 'Login successfully',
        input1: 'Please enter phone number',
        input2: 'Please enter a 6-digit code',
        input3: 'Please enter country name',
        input4: 'Please enter country email',
        reSend: ' resend',
        getCode: 'Get code',
        register: 'Register',
        login: 'Log in now',
        tipTitle: 'Warm Tips',
        tip1: 'The Zhiyuan Open Complex platform is only open to some users. Please log in with your Zhiyuan community account (the QR code will become invalid after scanning once)',
        tip2: 'During the test period, logging in means you agree',
    },
    register: {
        errorTip1: 'The phone number format is incorrect',
        errorTip2: 'The email format is incorrect',
        successTip1: 'Registration successfully, please log in',
        title: 'User Registration',
        name: 'Name',
        namePlaceholder: 'Please enter your name',
        phone: 'Mobile number',
        phonePlacholder: 'Please enter your phone number',
        email: 'Email',
        emailPlacholder: 'Please enter your email',
        company: 'Company',
        companyPlaceholder: 'Please enter your company name',
        institutionType: 'Institution Type',
        institutionTypePlaceholder: 'Please select your institution type',
        position: 'Position',
        positionPlaceholder: 'Please enter your position',
        academicField: 'Academic Field',
        academicFieldPlaceholder: 'Please enter your academic field',
        deparment: 'Department',
        departmentPlaceholder: 'Please enter your department name',
        tip1: 'I have read and accepted ',
        tip3: ', please fill in the real information, otherwise the application will not be accepted',
        cancel: 'Cancel',
        register: 'Register',
        registerWarning: 'Please read and accepted agreement'
    },
    common: {
        isLoading: 'loading…',
        errorVideoTip: 'load fail',
        home: 'Home',
        joinUs: 'Brain',
        aboutUs: 'Brain',
        aboutUs1: 'Tech Report',
        userCenter: 'User Center',
        guide: 'Usage Guidelines',
        logout: 'Logout',
        register: 'Register',
        login: 'Login',
        uploadSuccess: 'Upload successfully',
        uploadFailed: 'Upload failed',
        deleteSucess: 'Delete successfully',
        generate: 'generate',
        history: 'History Record',
        approval: 'APPROVAL MANAGEMENT',
        approvalRecord: 'Approval Record',
        noPermission: 'Please contact the administrator to apply for permission and try again',
        tip1: 'By signing up during the beta phase, you agree to the',
        and: ' and ',
        agreement1: 'Brain Server Terms of Service',
        agreement2: 'Prohibited Conduct Policy',
        agreement3: 'Privacy Policy',
        noData: 'No Data',
        phoneLogin: 'Phone Login',
        emailLogin: 'Email Login',
    },
    // 主页
    home: {
        banner: {
            title: 'Biomolecular Foundation Model',
            btn1: 'Future reports',
            bioTitlePart1: 'Biomolecular',
            bioTitlePart2: 'Foundation',
            bioTitlePart3: 'Model',
            bioSubTitle: 'Brain2 combines generative AI with all-atom biomolecular models to accurately predict structures and interactions of biomolecules. Beyond static views, it unveils the dynamic conformational landscapes of proteins, enabing deeper mechanistic insights into biological functions and accelerating next-generation therapeutic discovery',
        },
        intro: {
            // title: 'Model introduction',
            // subTitle: 'From static structure prediction to conformational ensemble modeling',
            next: {
                ft1: 'All-Atom Model',
                ft2: 'Unify molecule scales',
                ft3: 'Multimer interactions',
                ft4: 'Ensemble modeling',
            },
            leftInfo: {
                title: 'Mainstream Models',
                subTitle: 'Multiple models',
                sevenInfo: [
                    '蛋白质与核酸序列语言模型',
                    '蛋白质、核酸、小分子结构预测模型',
                    '蛋白质构象动态预测模型',
                    '蛋白质功能预测模型',
                    '蛋白质设计生成模型',
                    '小分子对接预测模型',
                    '小分子生化性质预测模型'
                ],
            },
            rightInfo: {
                title: 'All-Atom Biomolecular Model',
                subTitle: 'Single model',
                fourInfo: [
                    'Unifying understanding and generation of macro- and small molecules',
                    'From structure prediction to distribution modeling',
                    'advance drug target discovery and molecular design',
                ],
            },
        },
        performance: {
            title: 'Model Performance',
            section1: {
                title: 'Model Outcomes',
                over: 'Over 36 consecutive months',
                title2: 'Consistent top performance in CAMEO protein prediction (36 months)'
            },
            section2: {
                title: 'Model features',
                subTitle: 'Has the capability to extensively explore the conformational space of proteins',
                info: 'In terms of model empowerment, we have discussed collaborations with several domestic and international biological laboratories, including Tsinghua University, Changping Laboratory  and Heidelberg University in Germany as well as leading pharmaceutical companies such as Atom High-Tech, to conduct research on drugability and molecular mechanisms',
                leftInfo:
                    'Our team was the only one that successfully predicted the conformation distribution of proteins among the 23 participating teams In the CASP16 competition',
                rightInfo: 'Massive Sampling of the TICA Map for the Villin protein',
                leftMolxInfo: 'The conformational distribution of T1200 (Wild Type) is relatively compact',
                rightMolxInfo: 'T1300 (GLY6 Linker) exhibits a broader range of conformational distribution',
                info2: 'Our team was the only one that successfully predicted the conformation distribution of proteins among the 23 participating teams In the CASP16 competition (qualitatively consistent with the experimental data)',
            },
            section3: {
                subTitle: 'Achieves leading performance in protein, DNA, and RNA structure prediction tasks',
                desc1: 'RNA structure',
                desc2: 'DNA-protein complex structure',
                desc3: 'Protein-protein complex structure',
            },
            section4: {
                title: 'Demonstrates outstanding performance in the high-resolution analysis of biomolecular interactions',
                desc: 'Brain successfully predicts two distinct binding sites between the protein and ligand (PDB ID: 7DT9)',
            }
        },
        application: {
            title: 'Model features',
            more: 'learn more',
            sbt1: 'Model Large-scale Assembly',
            subInfo1: 'Brain2 incorporates symmetry optimization strategies to efficiently and accurately model large, complex symmetric assemblies, including icosahedral (I), octahedral (O), and tetrahedral (T) symmetries',
            subInfo11: 'The illustration displays the Methanococcus icosahedral encapsulin (PDB ID: 7BCV), comprising 15,960 residues, with a TM-score of 0.903',
            sbt2: 'Multimer Structure Prediction',
            subInfo2: 'The complex of N-myristoyltransferase with the Indazole inhibitor IMP-917 (PDB code: 6tw5) has a predicted error of 2.1 Å',
            subInfo21: 'predicted error of 4.3 Å',
            sbt3: 'Protein Ligand Interaction Prediction',
            subInfo3: 'IclR–4-hydroxybenzoic acid complex structure(PDB ID: 7CUO)',
            subInfo31: 'ligand RMSD is less than 2 Å',
            sbt4: 'Conformational change prediction',
            subInfo4: 'Brain2 bridges static structure prediction and dynamic conformational ensemble modeling, offering key insights into the regulatory mechanisms of dynamic proteins such as kinases',
            subInfo41: 'The illustration captures the conformational change of Src kinase transitioning from the inactive to the active state (PDB ID: 2SRC → 1Y57)',
            subInfo42: 'RMSD between conformations is  3.68 Å',
            sbt5: 'Prediction of multi-site interactions with small molecules',
            subInfo5: 'Brain2 accurately predicts diverse binding modes between proteins and ligands, facilitating the discovery of cryptic pockets and providing a reliable structural basis for drug development',
            subInfo51: 'The illustration shows the human PPARγ ligand-binding domain in complex with perfluorooctanoic acid (PDB ID: 8U57)',
            sbt6: 'Motif Scaffolding Design (Beta)',
            subInfo6: 'Brain2 enables protein design through generative modeling',
            subInfo61: 'The illustration presents the bacterial barstar–barnase complex (PDB ID: 7MRX). Leveraging the key functional motif of barstar, Brain2 designed and constructed de novo scaffold proteins',
            sbt7: 'Flexible region prediction',
            subInfo7: 'Leveraging an all-atom modeling strategy, Brain2 demonstrates significant advantages in capturing the conformational diversity of flexible regions',
            subInfo71: 'The illustration depicts a structure in which two domains are connected by a disordered region (PDB ID: 4NPF),  Brain2 is capable of sampling the flexible conformational variations in this region',
            circle1: 'Protein',
            circle2: 'Property',
            circle3: 'Nucleic Acid',
            circle4: 'Ensemble',
            circle5: 'Small Molecular',
            circle6: 'Structure',
            intro: {
                titlePart1: 'Model',
                titlePart2: 'Introduction',
                subTitle: 'Bridging static structure prediction and dynamic ensemble modeling',
                card1: {
                    titlePart1: 'Accurate Structure',
                    titlePart2: 'Prediction at Atom Level',
                    desc: 'Precisely construct the single-chain conformations of proteins, RNA, and DNA through the integration of diverse levels of information, spanning atoms, residues, and functional motifs',
                },
                card2: {
                    titlePart1: 'Precise Multimer',
                    titlePart2: 'Interaction Prediction',
                    desc: 'Accurately predict multi-chain interactions across a spectrum of molecular scales, ranging from interactions within protein-small molecule complexes to those within ultra-large molecular assemblies',
                },
                card3: {
                    titlePart1: 'Flexible',
                    titlePart2: 'Region Prediction',
                    desc: 'Capture intricate side-chain interactions in disordered protein regions through all-atom biomolecular foundation models, elucidating the mechanisms underlying alterations in flexible domains',
                },
                card4: {
                    titlePart1: 'Conformational',
                    titlePart2: 'Ensemble Modeling',
                    desc: 'Enable efficient exploration of conformational landscapes to capture transient conformational alterations critical for drug discovery, potentially transforming "undruggable" proteins into viable therapeutic targets',
                },
            },
            atom: {
                titlePart1: 'All-Atom',
                titlePart2: 'Biomolecular Model',
                desc: 'Brain2 learns atomic-level distributions to accurately reconstruct complete molecular structures with near-experimental fidelity, enabling high-resolution modeling of dynamic conformations and critical binding sites'
            },
            performance: {
                titlePart1: 'Model',
                titlePart2: 'Performance',
            }
        },
        feature: {
            titlePart1: 'Model',
            titlePart2: 'Features',
        },
        desc: {
            caspTitle: 'Advanced conformation distribution prediction in CASP16',
            leftMolxInfo: 'T1200 (Wild Type) shows a relatively compact conformation distribution',
            rightMolxInfo: 'T1300 (GLY6 linker) shows a broader conformation distribution',
            section1: {
                title: 'Leading performance in structure prediction tasks',
                subTitle: 'DNA, and RNA structure prediction tasks',
                desc1: 'RNA structure',
                desc2: 'DNA-protein complex structure',
                desc3: 'Protein-protein complex structure',
            },
            section2: {
                title: 'Understand physiologically relevant molecular interactions',
                desc: 'The capability of Brain2 to identify ligands with multiple binding sites is exemplified by PDB: 7DT9',
            }
        },
        sence: {
            title: 'Application Scenarios',
            titles: ['Structure Prediction', 'Interaction Prediction', 'Small Molecule Screening', 'Antibody Screening'],
            infos: [
                '加速药物分子虚拟筛选，提升早期药物发现效率',
                '通过对蛋白质-配体和蛋白质-蛋白质相互作用的分析，优化抗体药物、疫苗设计',
                '通过对蛋白质的精确的理解，推动生物材料、人工酶、生物传感器设计',
                '基于蛋白质结构的精准预测，提升病毒载体的性能',
            ],
        },
    },
};
